// CANCELLED outlines generated from the bundled OFL Noto Sans font.
// Vector artwork keeps the visible watermark out of selectable invoice text.
export const cancelledWatermarkHeight = 135.15;
export const cancelledWatermarkPath = [
  { op: 'm', c: [62.97, 14.55] },
  { op: 'c', c: [34.74, 14.55, 17.49, 34.68, 17.49, 67.58] },
  { op: 'c', c: [17.49, 100.23, 32.59, 120.6, 62.79, 120.6] },
  { op: 'c', c: [74.33, 120.6, 84.45, 118.39, 94.27, 115.45] },
  { op: 'l', c: [94.27, 129.81] },
  { op: 'c', c: [84.45, 133.49, 74.88, 135.15, 60.39, 135.15] },
  { op: 'c', c: [20.25, 135.15, 0.0, 108.64, 0.0, 67.39] },
  { op: 'c', c: [0.0, 27.62, 22.65, 0.0, 63.16, 0.0] },
  { op: 'c', c: [77.03, 0.0, 89.12, 2.58, 99.43, 7.73] },
  { op: 'l', c: [92.8, 21.73] },
  { op: 'c', c: [84.7, 18.04, 74.76, 14.55, 62.97, 14.55] },
  { op: 'h', c: [] },
  { op: 'm', c: [205.49, 133.31] },
  { op: 'l', c: [189.65, 92.62] },
  { op: 'l', c: [137.54, 92.62] },
  { op: 'l', c: [121.89, 133.31] },
  { op: 'l', c: [105.14, 133.31] },
  { op: 'l', c: [156.51, 1.29] },
  { op: 'l', c: [171.42, 1.29] },
  { op: 'l', c: [222.61, 133.31] },
  { op: 'h', c: [] },
  { op: 'm', c: [169.95, 38.11] },
  { op: 'c', c: [168.85, 35.17, 165.16, 22.83, 163.69, 18.41] },
  { op: 'c', c: [161.97, 26.02, 159.45, 33.94, 157.98, 38.11] },
  { op: 'l', c: [143.07, 77.89] },
  { op: 'l', c: [184.68, 77.89] },
  { op: 'h', c: [] },
  { op: 'm', c: [344.87, 133.31] },
  { op: 'l', c: [325.54, 133.31] },
  { op: 'l', c: [255.2, 24.12] },
  { op: 'l', c: [254.47, 24.12] },
  { op: 'c', c: [254.96, 32.71, 255.94, 46.34, 255.94, 59.84] },
  { op: 'l', c: [255.94, 133.31] },
  { op: 'l', c: [240.66, 133.31] },
  { op: 'l', c: [240.66, 1.84] },
  { op: 'l', c: [259.8, 1.84] },
  { op: 'l', c: [329.96, 110.66] },
  { op: 'l', c: [330.69, 110.66] },
  { op: 'c', c: [330.33, 104.77, 329.41, 87.83, 329.41, 76.04] },
  { op: 'l', c: [329.41, 1.84] },
  { op: 'l', c: [344.87, 1.84] },
  { op: 'h', c: [] },
  { op: 'm', c: [436.94, 14.55] },
  { op: 'c', c: [408.7, 14.55, 391.46, 34.68, 391.46, 67.58] },
  { op: 'c', c: [391.46, 100.23, 406.55, 120.6, 436.75, 120.6] },
  { op: 'c', c: [448.29, 120.6, 458.42, 118.39, 468.24, 115.45] },
  { op: 'l', c: [468.24, 129.81] },
  { op: 'c', c: [458.42, 133.49, 448.84, 135.15, 434.36, 135.15] },
  { op: 'c', c: [394.22, 135.15, 373.96, 108.64, 373.96, 67.39] },
  { op: 'c', c: [373.96, 27.62, 396.61, 0.0, 437.12, 0.0] },
  { op: 'c', c: [450.99, 0.0, 463.08, 2.58, 473.39, 7.73] },
  { op: 'l', c: [466.76, 21.73] },
  { op: 'c', c: [458.66, 18.04, 448.72, 14.55, 436.94, 14.55] },
  { op: 'h', c: [] },
  { op: 'm', c: [570.43, 133.31] },
  { op: 'l', c: [496.96, 133.31] },
  { op: 'l', c: [496.96, 1.84] },
  { op: 'l', c: [570.43, 1.84] },
  { op: 'l', c: [570.43, 16.39] },
  { op: 'l', c: [513.53, 16.39] },
  { op: 'l', c: [513.53, 57.45] },
  { op: 'l', c: [567.11, 57.45] },
  { op: 'l', c: [567.11, 71.81] },
  { op: 'l', c: [513.53, 71.81] },
  { op: 'l', c: [513.53, 118.76] },
  { op: 'l', c: [570.43, 118.76] },
  { op: 'h', c: [] },
  { op: 'm', c: [599.34, 133.31] },
  { op: 'l', c: [599.34, 1.84] },
  { op: 'l', c: [615.91, 1.84] },
  { op: 'l', c: [615.91, 118.58] },
  { op: 'l', c: [673.36, 118.58] },
  { op: 'l', c: [673.36, 133.31] },
  { op: 'h', c: [] },
  { op: 'm', c: [695.82, 133.31] },
  { op: 'l', c: [695.82, 1.84] },
  { op: 'l', c: [712.39, 1.84] },
  { op: 'l', c: [712.39, 118.58] },
  { op: 'l', c: [769.84, 118.58] },
  { op: 'l', c: [769.84, 133.31] },
  { op: 'h', c: [] },
  { op: 'm', c: [865.77, 133.31] },
  { op: 'l', c: [792.3, 133.31] },
  { op: 'l', c: [792.3, 1.84] },
  { op: 'l', c: [865.77, 1.84] },
  { op: 'l', c: [865.77, 16.39] },
  { op: 'l', c: [808.87, 16.39] },
  { op: 'l', c: [808.87, 57.45] },
  { op: 'l', c: [862.46, 57.45] },
  { op: 'l', c: [862.46, 71.81] },
  { op: 'l', c: [808.87, 71.81] },
  { op: 'l', c: [808.87, 118.76] },
  { op: 'l', c: [865.77, 118.76] },
  { op: 'h', c: [] },
  { op: 'm', c: [1000.0, 66.29] },
  { op: 'c', c: [1000.0, 110.72, 974.53, 133.31, 931.32, 133.31] },
  { op: 'l', c: [894.68, 133.31] },
  { op: 'l', c: [894.68, 1.84] },
  { op: 'l', c: [935.19, 1.84] },
  { op: 'c', c: [974.96, 1.84, 1000.0, 23.94, 1000.0, 66.29] },
  { op: 'h', c: [] },
  { op: 'm', c: [982.51, 66.84] },
  { op: 'c', c: [982.51, 31.73, 964.46, 16.02, 932.79, 16.02] },
  { op: 'l', c: [911.25, 16.02] },
  { op: 'l', c: [911.25, 119.13] },
  { op: 'l', c: [929.11, 119.13] },
  { op: 'c', c: [964.71, 119.13, 982.51, 101.7, 982.51, 66.84] },
  { op: 'h', c: [] },
];
export const cancelledWatermarkSvgPath = cancelledWatermarkPath
  .map(({ op, c }) => (op === 'h' ? 'Z' : op.toUpperCase() + c.join(' ')))
  .join(' ');
